import { IPriceSnapshotState } from '@/store/pricesnapshot';
import { IPriceSnapshotMutations } from './mutations.types';
import { IPriceSnapshotData } from '@/models';

export const mutations: IPriceSnapshotMutations = {
  SET_PRICESNAPSHOTS(
    state: IPriceSnapshotState,
    payload: IPriceSnapshotData[]
  ): void {
    state.priceSnapshots = payload;
  },

  ADD_PRICESNAPSHOT(
    state: IPriceSnapshotState,
    payload: IPriceSnapshotData
  ): void {
    state.priceSnapshots.unshift(payload);
  },

  UPDATE_PRICESNAPSHOT(
    state: IPriceSnapshotState,
    payload: IPriceSnapshotData
  ): void {
    const index = state.priceSnapshots.findIndex(
      (pricesnapshot: IPriceSnapshotData) => pricesnapshot.id === payload.id
    );

    state.priceSnapshots.splice(index, 1, payload);
  },

  REMOVE_PRICESNAPSHOT(state: IPriceSnapshotState, payload: number): void {
    const index = state.priceSnapshots.findIndex(
      (pricesnapshot: IPriceSnapshotData) => pricesnapshot.id === payload
    );

    state.priceSnapshots.splice(index, 1);
  },

  SET_COUNT(state: IPriceSnapshotState, payload: number): void {
    state.count = payload;
  },

  INCREMENT_COUNT(state: IPriceSnapshotState): void {
    state.count += 1;
  },

  DECREMENT_COUNT(state: IPriceSnapshotState): void {
    state.count -= 1;
  }
};
